var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { ColumnMetaDateFormat } from '@common/api';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { downloadFileViaBlob, farseerFilesApi } from '@data/rest/api';
import { dateToSerial } from '@util/number';
import { formatDateWithFormat } from '../../util';
export function globalLoadingWrapped(action) {
    return __awaiter(this, void 0, Promise, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = undefined;
                    startGlobalLoading();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, action()];
                case 2:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    stopGlobalLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/, result];
            }
        });
    });
}
export function downloadFarseerFile(farseerFileId, filename) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        var file;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, farseerFilesApi.get(farseerFileId)];
                                case 1:
                                    file = _a.sent();
                                    return [4 /*yield*/, downloadFileViaBlob(file, filename)];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var dateFormatObjects = (_a = {},
    _a[ColumnMetaDateFormat.DD_MM_YYYY] = {
        regex: /^(\d{1,2})[\.\/\-](\d{1,2})[\.\/\-](\d{2,4})[\.\/\-]{0,1}$/,
        dayjsFormat: 'DD/MM/YYYY',
        dayIndex: 1,
        monthIndex: 2,
        yearIndex: 3,
    },
    _a[ColumnMetaDateFormat.MM_DD_YYYY] = {
        regex: /^(\d{1,2})[\.\/\-](\d{1,2})[\.\/\-](\d{2,4})[\.\/\-]{0,1}$/,
        dayjsFormat: 'MM/DD/YYYY',
        dayIndex: 2,
        monthIndex: 1,
        yearIndex: 3,
    },
    _a[ColumnMetaDateFormat.YYYY_MM_DD] = {
        regex: /^(\d{2,4})[\.\/\-](\d{1,2})[\.\/\-](\d{1,2})[\.\/\-]{0,1}$/,
        dayjsFormat: 'YYYY-MM-DD',
        dayIndex: 3,
        monthIndex: 2,
        yearIndex: 1,
    },
    _a[ColumnMetaDateFormat.MM_YYYY] = {
        regex: /^(\d{1,2})[\.\/\-](\d{2,4})[\.\/\-]{0,1}$/,
        dayjsFormat: 'MM/YYYY',
        dayIndex: null,
        monthIndex: 1,
        yearIndex: 2,
    },
    _a[ColumnMetaDateFormat.YYYY_MM] = {
        regex: /^(\d{2,4})[\.\/\-](\d{1,2})[\.\/\-]{0,1}$/,
        dayjsFormat: 'YYYY-MM',
        dayIndex: null,
        monthIndex: 2,
        yearIndex: 1,
    },
    _a);
/**
 * Parses raw date value based on the given format,
 * sets the hours to 12:00:00 (to avoid timezone errors)
 * and the date to 1 if only month and year are available
 * @param rawDate raw date value
 * @param format format to parse the date by
 * @returns native JavaScript `Date` object or null if not able to parse
 */
export function parseDateWithImportFormat(rawDate, format) {
    if (format === undefined) {
        return null;
    }
    if (format === ColumnMetaDateFormat.EXCEL && typeof rawDate === 'number') {
        // EXCEL stores dates as number of day from 1.1.1900 (starting with 1)
        var daysUnixEpoch = rawDate - 25569; // 25 569 days from 01.01.1900 to 01.01.1970
        var secondsUnixEpoch = daysUnixEpoch * 86400; // 24 * 60 * 60 = 86 400 seconds in day
        var parsedDate = new Date(secondsUnixEpoch * 1000); // JavaScript native Date stores time in miliseconds
        return new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate(), 12, 0, 0);
    }
    else if (format === ColumnMetaDateFormat.UNIX && typeof rawDate === 'number') {
        // UNIX date is saved as seconds from 1.1.1970
        var parsedDate = new Date(rawDate * 1000);
        return new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate(), 12, 0, 0);
    }
    else if (format === ColumnMetaDateFormat.ISO && typeof rawDate === 'string') {
        // ISO date is saved in string such as "2022-12-31T13:14:15Z", JavaScript Date can parse it automatically
        var parsedDate = new Date(rawDate);
        return new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate(), 12, 0, 0);
    }
    else if (typeof rawDate === 'string') {
        // use regex for parsing date
        var formatObject = dateFormatObjects[format];
        if (formatObject === undefined) {
            // no regex defined for format
            return null;
        }
        var matches = rawDate.match(formatObject.regex);
        if (matches === null) {
            // string value does not match regex
            return null;
        }
        var month = Number.parseInt(matches[formatObject.monthIndex]);
        var year = Number.parseInt(matches[formatObject.yearIndex]);
        var yearAdjusted = year < 100 ? 2000 + year : year;
        var day = formatObject.dayIndex !== null ? Number.parseInt(matches[formatObject.dayIndex]) : 1;
        return new Date(yearAdjusted, month - 1, day, 12, 0, 0);
    }
    return null;
}
export function convertDateToImportFormat(date, format) {
    if (date === null || format === undefined) {
        return null;
    }
    if (format === ColumnMetaDateFormat.EXCEL) {
        // EXCEL stores dates as serial numbers
        return dateToSerial(date);
    }
    else if (format === ColumnMetaDateFormat.UNIX) {
        // UNIX date is saved as seconds from 1.1.1970
        return date.getTime() / 1000;
    }
    else if (format === ColumnMetaDateFormat.ISO) {
        // ISO date is saved in string such as "2022-12-31T13:14:15Z"
        return date.toISOString();
    }
    else {
        // return string matching format
        var dateFormatObject = dateFormatObjects[format];
        if (dateFormatObject === undefined) {
            return null;
        }
        var formattedDate = formatDateWithFormat(date, dateFormatObject.dayjsFormat);
        return formattedDate;
    }
}
